"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalAnalytics = exports.Analytics = void 0;
var ua_parser_js_1 = __importDefault(require("ua-parser-js"));
var __1 = require("..");
var Session_1 = require("./Session");
var Page_1 = require("./Page");
var User_1 = require("./User");
var utils_1 = require("../utils/utils");
var log_1 = require("../utils/log");
var Analytics = /** @class */ (function () {
    function Analytics() {
        // impression request queue
        this.impression_queue = [];
        this.impression_queue_timer = null;
        // viewability request queue
        this.viewability_queue = [];
        this.viewability_queue_timer = null;
        // session and page fail count
        this.session_fail_count = 0;
        this.page_fail_count = 0;
    }
    Analytics.prototype.sendSessionPageAnalytics = function () {
        var _a;
        if (Session_1.globalSession.id && Page_1.globalPage.id && (!Session_1.globalSession.session_analytics_logged || !Page_1.globalPage.page_analytics_logged)) {
            Session_1.globalSession.session_analytics_logged = true;
            Page_1.globalPage.page_analytics_logged = true;
            // Parse User Agent
            var ua = new ua_parser_js_1.default((0, utils_1.getUserAgent)());
            var referrer = ((_a = (0, utils_1.getReferrer)()) === null || _a === void 0 ? void 0 : _a.href) || "";
            var url = (0, utils_1.getURL)();
            // const href = url?.href || "";
            var origin_1 = (url === null || url === void 0 ? void 0 : url.origin) || "";
            var path = (url === null || url === void 0 ? void 0 : url.pathname) || "";
            var search = (url === null || url === void 0 ? void 0 : url.search) || "";
            if (__1.globalSettings.analytics.url_path_groupings.length) {
                var path_groupings = __1.globalSettings.analytics.url_path_groupings;
                for (var _i = 0, path_groupings_1 = path_groupings; _i < path_groupings_1.length; _i++) {
                    var path_grouping = path_groupings_1[_i];
                    var regex = (0, utils_1.escapeRegExp)(path_grouping);
                    if (path.match("^".concat(regex, ".*"))) {
                        path = path_grouping;
                        break;
                    }
                }
            }
            var page_url = origin_1 + path;
            if (!ua.getOS().name || !ua.getBrowser().name) {
                var error_message = 'Couldn\'t parse UA: ' + (0, utils_1.getUserAgent)();
                // Create a new standard Error object
                var error = new Error(error_message);
                // Send error analytics
                exports.globalAnalytics.sendErrorAnalytics(error, 'UA_PARSER');
            }
            var postData = {
                'session_id': (0, utils_1.validateValue)(Session_1.globalSession.id, 'string', '', 256),
                'property_id': (0, utils_1.validateValue)(__1.globalSettings.property_id, 'string', '', 256),
                'browser': (0, utils_1.validateValue)((ua.getBrowser().name || ""), 'string', '', 256),
                'device': (0, utils_1.validateValue)((ua.getDevice().type || "desktop"), 'string', '', 256),
                'os': (0, utils_1.validateValue)((ua.getOS().name || ""), 'string', '', 256),
                'page_id': (0, utils_1.validateValue)(Page_1.globalPage.id, 'string', '', 256),
                'session_depth': (0, utils_1.validateValue)(Session_1.globalSession.data.depth, 'number', '', 999),
                'page_url': (0, utils_1.validateValue)(page_url, 'string', '', 2048),
                'page_search': (0, utils_1.validateValue)(search, 'string', '', 2048),
                'page_referrer': (0, utils_1.validateValue)(referrer, 'string', '', 2048),
                'utm_source': (0, utils_1.validateValue)(Session_1.globalSession.data.utm.source, 'string', '', 256),
                'utm_medium': (0, utils_1.validateValue)(Session_1.globalSession.data.utm.medium, 'string', '', 256),
                'utm_campaign': (0, utils_1.validateValue)(Session_1.globalSession.data.utm.campaign, 'string', '', 256),
                'utm_term': (0, utils_1.validateValue)(Session_1.globalSession.data.utm.term, 'string', '', 256),
                'utm_content': (0, utils_1.validateValue)(Session_1.globalSession.data.utm.content, 'string', '', 256),
                'gclid': (0, utils_1.validateValue)(Session_1.globalSession.data.gclid, 'string', '', 256),
                'fbclid': (0, utils_1.validateValue)(Session_1.globalSession.data.fbclid, 'string', '', 256),
                'user_id': (0, utils_1.validateValue)(User_1.globalUser.getUUID(), 'string', '', 256),
                'new_user': (0, utils_1.validateValue)(Session_1.globalSession.data.new_user, 'boolean', false, 1),
                'browser_timestamp': (0, utils_1.validateValue)((0, utils_1.getISOTimestamp)(), 'string', '', 256),
            };
            if (__1.globalSettings.analytics.bigcrunch_page_meta && !checkNoIndex()) {
                var jsonLdMetaData = getJsonLdMetaData();
                var metaData = getMetaData();
                var page_meta = void 0;
                if (Object.keys(__1.globalSettings.analytics.page_meta_overrides).length) {
                    var page_meta_overrides = __1.globalSettings.analytics.page_meta_overrides;
                    for (var key in page_meta_overrides) {
                        if (key === path) {
                            page_meta = page_meta_overrides[key];
                            page_meta.url = (0, utils_1.validateValue)(page_url, 'string', '', 2048);
                            break;
                        }
                    }
                }
                if (!page_meta) {
                    page_meta = {
                        "url": (0, utils_1.validateValue)(page_url || jsonLdMetaData.url || metaData.url, 'string', '', 2048),
                        "author": (0, utils_1.validateValue)(jsonLdMetaData.author || metaData.author, 'string', '', 256),
                        "title": (0, utils_1.validateValue)(jsonLdMetaData.title || metaData.title, 'string', '', 256),
                        "thumbnailUrl": (0, utils_1.validateValue)(jsonLdMetaData.thumbnailUrl || metaData.thumbnailUrl, 'string', '', 256),
                        "articleSection": (0, utils_1.validateValue)(jsonLdMetaData.articleSection || metaData.articleSection, 'string', '', 256),
                        "keywords": (0, utils_1.validateValue)(jsonLdMetaData.keywords || metaData.keywords, 'string', '', 256),
                        "dateCreated": (0, utils_1.validateValue)(jsonLdMetaData.dateCreated || metaData.dateCreated, 'string', '', 256),
                        "dateModified": (0, utils_1.validateValue)(jsonLdMetaData.dateModified || metaData.dateModified, 'string', '', 256),
                        "datePublished": (0, utils_1.validateValue)(jsonLdMetaData.datePublished || metaData.datePublished, 'string', '', 256),
                    };
                }
                postData['page_meta_data'] = page_meta || {};
            }
            // Send session data to server
            Analytics.sendAnalyticsRequest('https://analytics-cf.bigcrunch.com/session-pages', postData).then(function () {
                (0, log_1.logInfo)('session and page logged');
                // globalSession.setSessionData();
            }).catch(function (error) {
                (0, log_1.logError)(error);
            });
        }
    };
    /**
     * Send impression data to server
     */
    Analytics.prototype.sendImpressionAnalytics = function (bidObj) {
        var _this = this;
        if (this.impression_queue_timer) {
            clearTimeout(this.impression_queue_timer);
        }
        // add bid to queue
        this.impression_queue.push({
            "page_id": (0, utils_1.validateValue)(bidObj.page_id, 'string', '', 256),
            "slot_id": (0, utils_1.validateValue)(bidObj.slotObj.id, 'string', '', 256),
            "impression_id": (0, utils_1.validateValue)(bidObj.impression_id, 'string', '', 256),
            "auction_id": (0, utils_1.validateValue)(bidObj.auction_id, 'string', '', 256),
            "refresh_count": (0, utils_1.validateValue)(bidObj.slotObj.refresh.count, 'number', '', 99),
            "ad_bidder": (0, utils_1.validateValue)(bidObj.bidder, 'string', '', 256),
            "ad_size": (0, utils_1.validateValue)(bidObj.data.w + 'x' + bidObj.data.h, 'string', '', 256),
            "ad_price": (0, utils_1.validateValue)(bidObj.data.price, 'number', '', 99),
            "ad_floor_price": (0, utils_1.validateValue)(bidObj.floor, 'number', '', 99),
            "min_bid_to_win": (0, utils_1.validateValue)(bidObj.min_bid_to_win, 'number', '', 99),
            "ad_impid": (0, utils_1.validateValue)(bidObj.data.impid, 'string', '', 256),
            "ad_adid": (0, utils_1.validateValue)(bidObj.data.adid, 'string', '', 256),
            "ad_cid": (0, utils_1.validateValue)(bidObj.data.cid, 'string', '', 256),
            "ad_crid": (0, utils_1.validateValue)(bidObj.data.crid, 'string', '', 256),
            "ad_dealid": (0, utils_1.validateValue)(bidObj.data.dealid, 'string', '', 256),
            "ad_demand_type": (0, utils_1.validateValue)(bidObj.demand_type, 'string', '', 256),
            "browser_timestamp": (0, utils_1.validateValue)((0, utils_1.getISOTimestamp)(), 'string', '', 256),
        });
        // set a timer to queue more impressions and then send request when timer is up
        this.impression_queue_timer = setTimeout(function () {
            var impressions = _this.impression_queue;
            _this.impression_queue = [];
            Analytics.sendAnalyticsRequest('https://analytics-cf.bigcrunch.com/impression', {
                'property_id': (0, utils_1.validateValue)(__1.globalSettings.property_id, 'string', '', 256),
                'impressions': impressions
            }).then(function () {
                (0, log_1.logInfo)('impressions logged');
            }).catch(function (error) {
                (0, log_1.logError)(error);
            });
        }, 250);
    };
    Analytics.prototype.sendAdViewabilityAnalytics = function (bidObj) {
        var _this = this;
        if (this.viewability_queue_timer) {
            clearTimeout(this.viewability_queue_timer);
        }
        this.viewability_queue.push({
            'page_id': (0, utils_1.validateValue)(bidObj.page_id, 'string', '', 256),
            'slot_id': (0, utils_1.validateValue)(bidObj.slotObj.id, 'string', '', 256),
            'impression_id': (0, utils_1.validateValue)(bidObj.impression_id, 'string', '', 256),
            'browser_timestamp': (0, utils_1.validateValue)((0, utils_1.getISOTimestamp)(), 'string', '', 256),
        });
        // set a timer to queue more impressions and then send request when timer is up
        this.viewability_queue_timer = setTimeout(function () {
            var viewability = _this.viewability_queue;
            _this.viewability_queue = [];
            Analytics.sendAnalyticsRequest('https://analytics-cf.bigcrunch.com/viewability', {
                'property_id': (0, utils_1.validateValue)(__1.globalSettings.property_id, 'string', '', 256),
                'viewability': viewability
            }).then(function () {
                (0, log_1.logInfo)('viewability logged');
            }).catch(function (error) {
                (0, log_1.logError)(error);
            });
        }, 250);
    };
    Analytics.prototype.sendErrorAnalytics = function (errorObj, errorType) {
        // Parse User Agent
        var ua = new ua_parser_js_1.default((0, utils_1.getUserAgent)());
        Analytics.sendAnalyticsRequest('https://analytics-cf.bigcrunch.com/error', {
            'property_id': (0, utils_1.validateValue)(__1.globalSettings.property_id, 'string', '', 256),
            'error_type': (0, utils_1.validateValue)(errorType, 'string', '', 256),
            'error_name': (0, utils_1.validateValue)(errorObj.name, 'string', '', 2048),
            'error_message': (0, utils_1.validateValue)(errorObj.message, 'string', '', 2048),
            'error_stack': (0, utils_1.validateValue)(errorObj.stack, 'string', '', 2048),
            'browser': (0, utils_1.validateValue)((ua.getBrowser().name || ""), 'string', '', 256),
            'device': (0, utils_1.validateValue)((ua.getDevice().type || "desktop"), 'string', '', 256),
            'os': (0, utils_1.validateValue)((ua.getOS().name || ""), 'string', '', 256),
            'browser_timestamp': (0, utils_1.validateValue)((0, utils_1.getISOTimestamp)(), 'string', '', 256),
        }).then(function () {
            (0, log_1.logInfo)('error logged');
        }).catch(function (error) {
            (0, log_1.logError)(error);
        });
    };
    Analytics.sendAnalyticsRequest = function (endpoint, postData) {
        return new Promise(function (resolve, reject) {
            (0, utils_1.fetchWithTimeout)(endpoint, 2000, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(postData)
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                // if success
                if (data.status === 200) {
                    resolve(data);
                }
                else {
                    reject();
                }
            })
                .catch(function (error) {
                (0, log_1.logError)(error);
                reject();
            });
        });
    };
    return Analytics;
}());
exports.Analytics = Analytics;
function checkNoIndex() {
    var metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
        var content = metaRobots.getAttribute('content');
        if (content.includes('noindex')) {
            return true;
        }
    }
    return false;
}
function getMetaData() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    // Select relevant meta tags
    var url = ((_a = document.querySelector('meta[property="og:url"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) || document.querySelector('link[rel="canonical"]')['href'] || "";
    var author = ((_b = document.querySelector('meta[property="article:author"]')) === null || _b === void 0 ? void 0 : _b.getAttribute('content')) || "";
    var title = ((_c = document.querySelector('meta[property="og:title"]')) === null || _c === void 0 ? void 0 : _c.getAttribute('content')) || document.title;
    var imageUrl = ((_d = document.querySelector('meta[property="og:image"]')) === null || _d === void 0 ? void 0 : _d.getAttribute('content')) || "";
    var articleSection = ((_e = document.querySelector('meta[property="article:section"]')) === null || _e === void 0 ? void 0 : _e.getAttribute('content')) || "";
    var dateCreated = ((_f = document.querySelector('meta[property="article:published_time"]')) === null || _f === void 0 ? void 0 : _f.getAttribute('content')) || "";
    var dateModified = ((_g = document.querySelector('meta[property="article:modified_time"]')) === null || _g === void 0 ? void 0 : _g.getAttribute('content')) || "";
    var datePublished = ((_h = document.querySelector('meta[property="article:published_time"]')) === null || _h === void 0 ? void 0 : _h.getAttribute('content')) || "";
    var keywords = [];
    document.querySelectorAll('meta[property="article:tag"]').forEach(function (tag) {
        keywords.push(tag.getAttribute('content'));
    });
    // Create an object to store the metadata
    var metaData = {
        url: url,
        author: author,
        title: title,
        thumbnailUrl: imageUrl,
        articleSection: articleSection,
        keywords: keywords.toString(),
        dateCreated: dateCreated,
        dateModified: dateModified,
        datePublished: datePublished,
    };
    return metaData;
}
function getJsonLdMetaData() {
    // Select all JSON-LD script tags
    var jsonLdScripts = document.querySelectorAll('script[type="application/ld+json"]');
    // const jsonLdDataArray = [];
    var jsonLdMetaData = {
        url: "",
        author: "",
        title: "",
        thumbnailUrl: "",
        articleSection: "",
        keywords: "",
        dateCreated: "",
        dateModified: "",
        datePublished: "",
    };
    // found flag
    var found = false;
    // Loop through each script tag and parse its content
    jsonLdScripts.forEach(function (jsonLdScript) {
        var _a;
        try {
            // if found, return
            if (found) {
                return;
            }
            // Parse JSON-LD
            var jsonData = JSON.parse(jsonLdScript.textContent.trim());
            if (jsonData.author) {
                found = true;
                jsonLdMetaData = {
                    url: jsonData.url || "",
                    author: ((_a = jsonData.author) === null || _a === void 0 ? void 0 : _a.name) || "",
                    title: jsonData.headline || jsonData.name || "",
                    thumbnailUrl: jsonData.thumbnailUrl || "",
                    articleSection: (jsonData.articleSection || "").toString(),
                    keywords: (jsonData.keywords || "").toString(),
                    dateCreated: jsonData.dateCreated || "",
                    dateModified: jsonData.dateModified || "",
                    datePublished: jsonData.datePublished || "",
                };
            }
            // jsonLdDataArray.push(jsonData);
        }
        catch (error) {
            (0, log_1.logWarn)('Error parsing JSON-LD:', error);
        }
    });
    // return jsonLdDataArray.length > 0 ? jsonLdDataArray : null;
    return jsonLdMetaData;
}
exports.globalAnalytics = new Analytics();
